import {APIRequest} from "../APIRequest.js";
import {signPayload} from "../../Crypto/utils";
import {RESOURCE} from "../../App/utils";
import jwtDecode from "jwt-decode";
import {decryptKBItem, decryptKBItemIfEncrypted} from "../../App/cryptoUtils";
export const LEDGER_API_URL = "https://ledger.openkbs.com/";

const timeout = 20000;

export const getAccount = async (accountId, privateKey, publicKey) => {
    const transactionJWT = await signPayload({accountId, resourceId: RESOURCE.tokens, publicKey}, accountId, publicKey, privateKey, 60)

    try {
        const response = await APIRequest('post', LEDGER_API_URL + 'account', {
            transactionJWT,
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

const ongoingRequests = {};
export let balanceJWT = {};
export let getBalanceJWT = async (accountId, walletPrivateKey, publicKey) => {
    // Check if there is an ongoing request for the account balance (getAccountBalances will cache balanceJWT for you)
    const cacheKey = `getAccountBalances-${accountId}`;
    if (ongoingRequests[cacheKey]) await ongoingRequests[cacheKey];
    if (balanceJWT[accountId]) {
        try {
            const { exp } = jwtDecode(balanceJWT[accountId]);
            const left = exp - Math.round(+new Date() / 1000);
            if (left > 60) {
                return balanceJWT[accountId];
            }
        } catch (e) {
            console.error(e);
        }
    }

    const privateKey = decryptKBItemIfEncrypted(walletPrivateKey);

    const transactionJWT = await signPayload({ accountId, publicKey }, accountId, publicKey, privateKey, 180);
    const res = await APIRequest('post', LEDGER_API_URL + 'account-balances', {
        signed: true,
        transactionJWT,
    });
    if (res?.data?.JWT) {
        balanceJWT[accountId] = res?.data?.JWT;
        return balanceJWT[accountId];
    }
};

export const getAccountBalances = async (accountId, privateKey, publicKey) => {
    const cacheKey = `getAccountBalances-${accountId}`;
    if (!ongoingRequests[cacheKey]) {
        ongoingRequests[cacheKey] = (async () => {
            const transactionJWT = await signPayload({accountId, publicKey}, accountId, publicKey, privateKey, 180);
            try {
                const res = await APIRequest('post', LEDGER_API_URL + 'account-balances', {
                    signed: true,
                    transactionJWT,
                }, {timeout});
                balanceJWT[accountId] = res?.data?.JWT;
                return res?.data;
            } catch (error) {
                console.error('API request error:', error);
                throw error;
            }
        })().finally(() => {
            delete ongoingRequests[cacheKey];
        });
    }
    const response = await ongoingRequests[cacheKey];
    return response?.data;
};

export const transactionsLimit = 25;
export const getAccountTransactions = async (accountId, privateKey, publicKey, lastEvaluatedKey = null, limit = transactionsLimit) => {
    const cacheKey = `getAccountTransactions-${accountId}-${lastEvaluatedKey || 'start'}-${limit}`;
    if (!ongoingRequests[cacheKey]) {
        ongoingRequests[cacheKey] = (async () => {
            const transactionJWT = await signPayload({accountId, publicKey}, accountId, publicKey, privateKey, 60);
            try {
                return await APIRequest('post', LEDGER_API_URL + 'transactions', {
                    transactionJWT,
                    limit,
                    lastEvaluatedKey
                }, {timeout});
            } catch (error) {
                console.error('API request error:', error);
                throw error;
            }
        })().finally(() => {
            delete ongoingRequests[cacheKey];
        });
    }
    const response = await ongoingRequests[cacheKey];
    return response?.data;
};
